import React, { lazy } from "react";

const ShareVideoAccessPage = lazy(() => import("./ShareVideoAccessPage"));

export { ShareVideoAccessPage };
